<template>
  <div>
    <br>
    <div class="card homepage">
      <img
        src="@/assets/homepage_splash.jpg"
        class="card-img-top"
        alt="Recreational Boat"
      >
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <h3>About the Survey</h3>
            <p>The National Recreational Boating Safety Program, under the administration of the United States Coast Guard, seeks as one of its strategic performance initiatives to improve upon and expand recreational boating data collection by conducting the National Recreation Boating Safety Survey (NRBSS).</p>
            <p>The NRBSS consists of two different surveys, a Participation Survey and an Exposure Survey. Most recently, the Participation Survey was conducted quarterly during 2018. The primary purpose of the NRBSS Participation Survey was to quantify and describe persons that went out on the water in recreational boats during 2018. The NRBSS Exposure Survey collected data on a monthly basis during 2018; its main purpose was to collect valid data necessary to estimate boating exposure hours reliably.</p>
          </div>
          <div class="col-md-6">
            <h3>Explore the Results</h3>

            <ul>
              <li
                v-for="page in pages"
                :key="page.title"
              >
                <router-link
                  :to="page"
                  class="text-capitalize"
                >
                  {{ page | titleFormat }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h3>Participate</h3>
            <p>When the next wave of NRBSS is scheduled, a sample of participants will receive an invitation with a unique access code to access and complete their survey.</p>
          </div>
          <div class="col-md-6">
            <h3>Download the Reports</h3>
            <ul>
              <li><a href="/data/NRBSS-Exposure-Survey-Final-Report-October-28-2020.pdf">Exposure Survey - Final Report</a></li>
              <li><a href="/data/NRBSS-Participation-Survey-Final-Report-October-28-2020_final.pdf">Participation Survey - Final Report</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Homepage',
  filters: {
    titleFormat: function (value) {
      if (value.includes('_')) {
        let split = value.split('_')
        return split[0] + ' (' + split[1] + ')'
      }
      return value
    }
  }
}
</script>
<style scoped>
.card {
  height: 100%;
  min-height: 100%;
}
</style>
